import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';  

@Pipe({
  name: 'isExist'
})

//值是否存在於列表某欄位中
export class IsExistPipe implements PipeTransform {

  transform(value: any,list:[],field:string): boolean {
   
    if(!field)
      return  _.findIndex(list, e=> e==value) >-1;
    else{
      if(!list || list.length<1 )
        return false;
      var item = _.find(list, e=> e[field]==value);
      return item ? true : false;
    }
   
    
  }

}
